export const dispoConstants = {
    DISPO_REQUEST: 'ALERTDISPO_MESSAGES_REQUEST',
    DISPO_SUCCESS: 'ALERTDISPO_MESSAGES_SUCCESS',
    DISPO_FAILURE: 'ALERTDISPO_MESSAGES_FAILURE',
};